import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../config';
import { paths } from '../../paths';

function OtpForm() {
  const [otp, setOtp] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedEmail = localStorage.getItem('email');
    if (storedEmail) {
      setEmail(storedEmail);
    } else {
      alert('Email not found, please sign up again.');
      navigate(paths.signup);
    }
  }, [navigate]);

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // verifyOtp resolves only on success (axios rejects non-2xx). The backend
      // returns 201 Created on a successful registration, so any 2xx means done.
      await axios.post(`${API_URL}/signup/verifyOtp`, { email, otp });
      localStorage.removeItem('email');
      navigate(paths.registrationSuccessSignup);
    } catch (error) {
      console.error('Error during OTP verification:', error);
      // Surface the backend's specific reason (Invalid OTP / expired /
      // "Too many incorrect attempts. Please sign up again.") when available.
      alert(
        error.response?.data?.message ||
          'Error during OTP verification. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full relative">
      {loading && (
        <div className="fixed inset-0 bg-black/20 backdrop-blur-[1px] z-50 flex items-center justify-center">
          <div className="w-8 h-8 border-4 border-black border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      <h1 className="text-4xl sm:text-5xl font-bold font-barlow text-black tracking-normal pb-2 mb-2">
        Verify OTP
      </h1>
      <p className="text-[11px] sm:text-xs text-gray-500 font-montserrat leading-relaxed max-w-md mb-6 lg:mb-5">
        We have sent a one-time password to <b>{email}</b>. Please enter it below to complete your registration. Check your <b>junk or spam folder</b> if you don't see it.
      </p>

      <form className="space-y-4" onSubmit={handleOtpSubmit}>
        <div className="flex flex-col gap-1 w-full">
          <label className="block text-[11px] font-bold text-black font-montserrat tracking-wider">
            One-Time Password
          </label>
          <input
            type="tel"
            name="otp"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter 6-digit OTP"
            required
            maxLength={6}
            className="w-full bg-[#CC5E15]/30 border text-gray-800 placeholder-black/70 text-xs rounded-sm px-3.5 py-2.5 focus:outline-none focus:ring-1 focus:ring-black/40 transition-all font-montserrat tracking-widest"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-black hover:bg-gray-900 text-white font-bold text-xs py-3 rounded-sm transition-colors tracking-widest font-montserrat mt-2"
        >
          Verify
        </button>
      </form>
    </div>
  );
}

export default OtpForm;